import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { TransactionListResponse } from '@frontend/transaction/types';

export class TransactionEquipmentClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchEquipmentNonProcessedTransactions(
        accountId: string,
        equipmentId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>
    ): Promise<TransactionListResponse> {
        return await this.apiPaginated<TransactionListResponse, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/non-processed-transactions`,
            queryParams
        );
    }
}
